
const navigationButtonsIds = require('./navigationButtonsIds');
var stateManager = require('../../utils/state/stateManager.js');
var logger = require('../../utils/logger/logger');
var viewUtil = require('../../utils/view/viewUtil');
var translator = require('../../utils/translator/translator');
const guidUtil = require('../../utils/guid/guidUtil.js');
var jobsServer = require('../../utils/jobs/jobsServer');
var shellAPIServer = require('../../utils/api/shellAPIServer');
var printUtil = require('../../utils/print/printUtil');
var azureTableUtil = require('../../utils/azureTables/azureTableUtil');
var azureTables = require('../../utils/azureTables/azureTables');
var staffUtility = require('../../utils/domain/staff/staffUtility');
var dateUtil = require('../../utils/dateUtil/dateUtil');
var businessDateUtil = require('../../utils/dateUtil/businessDateUtil');
var commonUtility = require('../../utils/domain/commonUtility');
var terminalUtility = require('../../utils/domain/terminalUtility');
var saleInitializer = require('../../utils/domain/sales/saleInitializer');
var storefrontUtility = require('../../utils/domain/storefrontUtility');
var constants = require('../../utils/domain/constants');
var controlSettingsUtils = require('../../utils/domain/settings/controlSettingsUtils');

var saleContextUtil = require('../Order/utils/saleContextUtil');
var staffLoginAction = require('../../utils/state/actions/staffLogin/staffLoginAction.js');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');
var navigationPageAction = require('../../utils/state/actions/views/navigationPage/navigationPageAction');
var tillStatusAction = require('../../utils/state/actions/views/tillStatus/tillStatusAction');

export function handleNavigationButtonOnClick(button)
{

   if (navigationButtonsIds.logOutButton == button)
   {
        logger.usage("Navigation.LogOutButton", "Staff clicked button to Logout");
        stateManager.getStore().dispatch(staffLoginAction.createAction(null));
   }

   if (navigationButtonsIds.clockingButton == button)
   {
        logger.usage("Navigation.clockingButton", "Staff clicked button to clock In/Out");

        viewUtil.showLoginDialogue(staff =>
        {
          openClockingDialogue(staff);
        });
   }

   if (navigationButtonsIds.openCloseTillButton == button)
   {
        logger.usage("Navigation.openCloseTill", "Staff clicked button to open/close till");

        var newTillStatus = "close";
        let newTillOpenFlag = false;
        var alertMessage = translator.getLabel("till_is_closed_successfully");
        
        if (stateManager.getStore().getState().tillStatus == "close")
        {
               newTillStatus = "open";
               newTillOpenFlag = true;
               alertMessage = translator.getLabel("till_is_opened_successfully");
        }

        stateManager.getStore().dispatch(tillStatusAction.createAction(newTillStatus));
        viewUtil.showSuccessAlert(alertMessage);

        jobsServer.addJob(guidUtil.generateGuid(), "OpenCloseTill",
                      async ()=>
                      {
                         await shellAPIServer.openCloseTill(newTillOpenFlag);
                      }, false, null, null, 1);
   }

   if (navigationButtonsIds.openCashDrawer == button)
   {
        logger.usage("Navigation.openCashDrawer", "Staff clicked button to open cash drawer");

        printUtil.openCashDrawer();
        viewUtil.showSuccessAlert(translator.getLabel("instructions_have_been_successfully_sent_to_open_the_cash_drawer"));

        jobsServer.addJob(guidUtil.generateGuid(), "OpenCashDrawer.AzureTables",
          async ()=>
          {
               //TODO:: let floatSession = cashFloatUtil.getLoadedFloatSession();
               
               var openCashDrawPayload = {};
               //openCashDrawPayload.floatSessionId = floatSession == null ? null : floatSession.id;
               openCashDrawPayload.floatSessionId = null;
               openCashDrawPayload.isOpenedByUser = true;
               openCashDrawPayload.openedBy = staffUtility.getLoginStaffCompleteName();
               openCashDrawPayload.reason = "Open Manually";
               openCashDrawPayload.dateTime = dateUtil.getNow();
               openCashDrawPayload.terminalCode = terminalUtility.getTerminalCode();

               var todayDate = businessDateUtil.getTodayBusinessDate();
               var franchisorId = commonUtility.getFranchisor().id;
               var propertyId = commonUtility.getProperty().id;

               var partitionKey = azureTableUtil.removeInvalidCharacters(`${franchisorId}::${propertyId}::${dateUtil.getYear(todayDate)}::${dateUtil.getMonth(todayDate)}::${todayDate}`);
               var rowKey = azureTableUtil.removeInvalidCharacters(`${partitionKey}::${guidUtil.generateGuid()}`);

               openCashDrawPayload.partitionKey = partitionKey;
               openCashDrawPayload.rowKey = rowKey;
               await azureTableUtil.upsertEntity(azureTables.AzureTableCashDrawerLogs, openCashDrawPayload);
          }, true);
   }

   if (navigationButtonsIds.outstanding == button || navigationButtonsIds.salesHistory == button)
   {
        logger.usage("Navigation.outstanding", "Staff clicked button to open outstanding sales");

        let filterCriteria = {};
        if (navigationButtonsIds.outstanding == button)
        {
               filterCriteria.paymentStatus = "unpaid";
               filterCriteria.saleStatus = "active";
        }

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
        navigationDialoguePayload.filterCriteria = filterCriteria;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.attendance == button)
   {
        logger.usage("Navigation.attendance", "Staff clicked button to open attendance");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.rota == button)
   {
        logger.usage("Navigation.rota", "Staff clicked button to open rota");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

    if (navigationButtonsIds.dailySummary === button)
    {
        logger.usage("Navigation.dailySummary", "Staff clicked button to open daily summary");

        const filterCriteria = {};
        const navigationDialoguePayload = { id: button, filterCriteria: filterCriteria };
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
    }

    if (navigationButtonsIds.driverSales === button)
    {
        logger.usage("Navigation.driverSales", "Staff clicked button to open Driver Sales Report");

        const filterCriteria = {};
        const navigationDialoguePayload = { id: button, filterCriteria: filterCriteria };
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
    }
    
   if (navigationButtonsIds.holidays == button)
   {
        logger.usage("Navigation.holidays", "Staff clicked button to open holidays");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.settings == button)
   {
        logger.usage("Navigation.Settings", "Staff clicked button to open settings");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.overview == button)
   {
        logger.usage("Navigation.Overview", "Staff clicked button to open overview screen");

        let navigationPagePayload  = {}
        navigationPagePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationPagePayload));
   }

   if (navigationButtonsIds.callLogs == button)
   {
        logger.usage("Navigation.CallLogs", "Staff clicked button to open call logs");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.navigationDesigner == button)
   {
        logger.usage("Navigation.Designer", "Staff clicked button to change layout");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.dineIn == button)
   {
        onDineInClick();
   }

   if (navigationButtonsIds.takeAway == button)
   {
        onTakeAwayClick();
   }

   if (navigationButtonsIds.collection == button)
   {
        onCollectionClick();
   }

   if (navigationButtonsIds.delivery == button)
   {
        onDeliveryClick();
   }
   if (navigationButtonsIds.freebies == button)
   {

        logger.usage("Navigation.Freebies", "Staff clicked button to see freebies");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.propertySnooze == button)
   {
        logger.usage("Navigation.PropertySnooze", "Staff clicked button to issue a snooze property");

        let navigationPagePayload  = {}
        navigationPagePayload.id = button;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationPagePayload));
   }

   if (navigationButtonsIds.staffMeal == button) 
   {
        logger.usage("Navigation.StaffMeal", "Staff clicked button to open StaffMeal");
        const sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeDineIn, storefrontUtility.getCurrentStorefront().id);
        sale.paymentMethod = constants.PaymentMethodVenuePaid;
        sale.saleType = constants.SaleTypeStaffMeal;
        saleContextUtil.openSale(sale, false);
   }

   if (navigationButtonsIds.guestMeal == button)
   {
        logger.usage("Navigation.GuestMeal", "Staff clicked button to see GuestMeal");
        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
   }

   if(navigationButtonsIds.itemSnooze == button){
     logger.usage("Navigation.ItemSnooze", "Staff clicked button to see ItemSnooze");
     let navigationPagePayload  = {}
     navigationPagePayload.id = button;
  
     stateManager.getStore().dispatch(navigationPageAction.createAction(navigationPagePayload));
   }
  
   if (navigationButtonsIds.cashingUp == button)
   {
        logger.usage("Navigation.CashingUp", "Staff clicked button for cashing up");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.voucher == button)
   {
        logger.usage("Navigation.Voucher", "Staff clicked button to issue a voucher");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
     
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.notifications == button)
   {
        logger.usage("Navigation.Notifications", "Staff clicked button to open notifications");

        let navigationDialoguePayload  = {}
        navigationDialoguePayload.id = button;
        navigationDialoguePayload.selectedNotificationId = null;
     
        stateManager.getStore().dispatch(navigationPageAction.createAction(navigationDialoguePayload));
   }

   if (navigationButtonsIds.menuSnooze == button)
   {
     logger.usage("Navigation.MenuSnooze", "Staff clicked button to menu snoozes");
     let navigationPagePayload  = {}
     navigationPagePayload.id = button;
  
     stateManager.getStore().dispatch(navigationPageAction.createAction(navigationPagePayload)); 
   }
}

function openClockingDialogue(staff)
{
     let navigationDialoguePayload  = {}
     navigationDialoguePayload.id = navigationButtonsIds.clockingButton;
     navigationDialoguePayload.staff = staff;
     
     stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
}

function onDineInClick()
{
     logger.usage("Navigation.DineIn", "Staff clicked button to enter a dineIn sale");

     if (storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty)
     {
          if (storefrontUtility.canHaveTableAssignment(storefrontUtility.getCurrentStorefront()) &&
              controlSettingsUtils.getMandatoryDetailsBeforeOrderDetails())
          {
               let navigationDialoguePayload  = {}
               navigationDialoguePayload.id = navigationButtonsIds.dineIn;
               navigationDialoguePayload.component = "table";
               
               stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
          }
          else
          {
               let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeDineIn, storefrontUtility.getCurrentStorefront().id)
               saleContextUtil.openSale(sale, false);
          }

          return;
     }

     const navigationDialoguePayload = {
          id: navigationButtonsIds.dineIn,
          component: "VenueDialogue",
          dispatchType: constants.DispatchTypeDineIn,
     };
     stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
}

function onTakeAwayClick()
{
     logger.usage("Navigation.TakeAway", "Staff clicked button to enter a takeaway sale");
     
     if (storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty)
     {  
          if (storefrontUtility.canHavePagerNumber(storefrontUtility.getCurrentStorefront()) &&
               controlSettingsUtils.getMandatoryDetailsBeforeOrderDetails())
           { 
               let navigationDialoguePayload  = {}
               navigationDialoguePayload.id = navigationButtonsIds.takeAway;
               navigationDialoguePayload.component = "pager";
               
               stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
           }
           else
           {
               let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeTakeAway, storefrontUtility.getCurrentStorefront().id)
               saleContextUtil.openSale(sale, false);
           }

           return;
     }

     const navigationDialoguePayload = {
          id: navigationButtonsIds.takeAway,
          component: "VenueDialogue",
          dispatchType: constants.DispatchTypeTakeAway,
     };
     stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
}

function onCollectionClick()
{
     logger.usage("Navigation.Collection", "Staff clicked button to enter a collection sale");
     if (storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty) 
     {
          if(controlSettingsUtils.getMandatoryDetailsBeforeOrderDetails())
          { 
               let navigationDialoguePayload  = {}
               navigationDialoguePayload.id = navigationButtonsIds.collection;
               navigationDialoguePayload.component = "customer";
               
               stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
          }
          else
          {
               let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeCollection, storefrontUtility.getCurrentStorefront().id)
               saleContextUtil.openSale(sale, false);
          }

     }
     else 
     {
          const navigationDialoguePayload = {
               id: navigationButtonsIds.collection,
               component: "VenueDialogue",
               dispatchType: constants.DispatchTypeCollection,
          };
          stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
     }
}

function onDeliveryClick()
{
     logger.usage("Navigation.Delivery", "Staff clicked button to enter a delivery sale");
     if (storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty) 
     {
          if(controlSettingsUtils.getMandatoryDetailsBeforeOrderDetails())
          { 
               let navigationDialoguePayload  = {}
               navigationDialoguePayload.id = navigationButtonsIds.delivery;
               navigationDialoguePayload.component = "customer";
               
               stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
          }
          else
          {
               let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeDelivery, storefrontUtility.getCurrentStorefront().id)
               saleContextUtil.openSale(sale, false);
          }
     } 
     else 
     {
          const navigationDialoguePayload = {
               id: navigationButtonsIds.delivery,
               component: "VenueDialogue",
               dispatchType: constants.DispatchTypeDelivery,
          };
          stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
     }
}